// Daro options in the cart (scripts/options/PLAN.md section 5): priced choices are separate "add-on" lines
// carrying the same _daro_group property as the line they belong to. They follow that line's quantity and go
// when it goes. cart.js calls syncCart() after every quantity change or removal.
window.DaroOptions = window.DaroOptions || {};

/**
 * Bring every add-on line's quantity in line with its parent line (0 when the parent is gone).
 * Returns the /cart/update.js response (with the requested sections), or null when nothing changed.
 */
window.DaroOptions.syncCart = async function syncCart(sections) {
  const routes = window.routes || {};
  const cart = await (await fetch(`${routes.cart_url || '/cart'}.js`, { cache: 'no-store' })).json();
  const parents = new Map();
  for (const item of cart.items) {
    const group = item.properties?._daro_group;
    if (group && !item.properties._daro_parent) parents.set(group, (parents.get(group) || 0) + item.quantity);
  }
  const updates = {};
  for (const item of cart.items) {
    const group = item.properties?._daro_group;
    if (!group || !item.properties._daro_parent) continue;
    const want = parents.get(group) || 0;
    if (item.quantity !== want) updates[item.key] = want;
  }
  if (!Object.keys(updates).length) return null;
  const body = { updates };
  if (sections) {
    body.sections = sections;
    body.sections_url = window.location.pathname;
  }
  const response = await fetch(`${routes.cart_update_url || '/cart/update'}.js`.replace(/\.js\.js$/, '.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  return response.json();
};

/**
 * Drop one optional add-on line (cart ✕ on a ticked checkbox add-on): the choice comes off its main line's
 * properties as well, then the cart sections re-render. Older add-ons without _daro_option just go.
 */
window.DaroOptions.removeAddon = async function removeAddon(key, button) {
  const routes = window.routes || {};
  const container = button?.closest('cart-items-component, cart-drawer-items');
  const sections = [...document.querySelectorAll('cart-items-component, cart-drawer-items')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean)
    .join(',');
  const post = (body) =>
    fetch(`${routes.cart_change_url || '/cart/change'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());
  container?.classList.add('cart-items-disabled');
  try {
    const cart = await (await fetch(`${routes.cart_url || '/cart'}.js`, { cache: 'no-store' })).json();
    const addon = cart.items.find((i) => i.key === key);
    if (!addon) return;
    const group = addon.properties?._daro_group;
    const option = addon.properties?._daro_option;
    const parent = cart.items.find((i) => i.properties?._daro_group === group && !i.properties._daro_parent);
    if (parent && option && option in parent.properties) {
      const { [option]: _, ...rest } = parent.properties;
      await post({ id: parent.key, quantity: parent.quantity, properties: rest });
    }
    const json = await post({ id: key, quantity: 0, sections, sections_url: window.location.pathname });
    if (json.sections && container?.updateSections) container.updateSections(json.sections);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = json.item_count));
  } catch (e) {
    console.error(e);
  } finally {
    container?.classList.remove('cart-items-disabled');
  }
};

// A line removed in another tab can leave its add-ons behind: tidy up on the cart page
if (/\/cart\/?$/.test(window.location.pathname)) {
  window.addEventListener('DOMContentLoaded', async () => {
    try {
      if (await window.DaroOptions.syncCart()) window.location.reload();
    } catch (e) {
      console.error(e);
    }
  });
}
